import { render, staticRenderFns } from "./RecruitDetail.vue?vue&type=template&id=1f76394a&scoped=true&"
import script from "./RecruitDetail.vue?vue&type=script&lang=js&"
export * from "./RecruitDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecruitDetail.vue?vue&type=style&index=0&id=1f76394a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76394a",
  null
  
)

export default component.exports